import React from 'react'
import { SpellSearch} from '../components/SpellSearch'


export const Test = () => {
  return (
    <SpellSearch />
  )
}
